import reducer from "./reducers";
import * as notificationsOperations from "./operations";

export { notificationsOperations };

export default reducer;
